export default "__VITE_PUBLIC_ASSET__d890b5ad__"